<template>
  <div class="payment">
    <md-radio class="md-simple" v-model="selectedOption" v-for="option in paymentOptions" :key="option.value" :value="option.method"><img :src="option.image"></md-radio>
  </div>
</template>

<script>

export default {
  props: ['availableOptions', 'disabled'],
  data() {
    return {
      selectedOption: null,
      paymentOptions: [{
        name: 'PayPal',
        image: '/img/cart/paypal.png',
        method: 'paypal'
      }, {
        name: 'Sofortüberweisung',
        image: '/img/cart/sofort.png',
        method: 'sofort'
      }, {
        name: 'Kreditkarte',
        image: '/img/cart/card.png',
        method: 'card'
      }].filter(o => !this.availableOptions || !this.availableOptions.length || this.availableOptions.some(a => a === o.method))
    };
  },
  watch: {
    selectedOption: function() {
      this.$emit('input', this.selectedOption);
    }
  }
};
</script>
<style lang="css" scoped>
  .payment >>> .md-simple img {
    height: 30px;
    width: auto;
    max-width: 100px;
  }
</style>
